import { HttpErrorResponse } from '@angular/common/http';
import * as ErrorActions from 'src/app/store/global-notification/actions/global-notification.action';
import { parseError } from 'src/app/utils/error-parse';
import { IGetDocumentsParams, IDocumentsQueryResult, IDocumentDownloadRequestObject } from './../../../models/document';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as DocumentLibraryActions from '../actions/document-library.actions';
import * as GlobalNotificationActions from '../../global-notification/actions/global-notification.action';
import { switchMap, catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { DocumentLibraryService } from 'src/app/services/http/document-library.service';


@Injectable()
export class DocumentLibraryEffects {



  constructor(private actions$: Actions, private documentLibraryService: DocumentLibraryService) { }

  getDocuments$ = createEffect(() => this.actions$.pipe(
    ofType<DocumentLibraryActions.GetDocuments>(DocumentLibraryActions.DocumentLibraryActionTypes.GET_DOCUMENTS),
    switchMap((action: DocumentLibraryActions.GetDocuments) => {
      return this.documentLibraryService.getDocuments(<IGetDocumentsParams>action.payload)
        .pipe(
          switchMap((res: any) => {
            if (res) {
              if (res.errorMessage) {
                return of(
                  new DocumentLibraryActions.GetDocumentsError(res.errorMessage),
                  new GlobalNotificationActions.NotificationErrorAction(res.errorMessage)
                );
              } else {
                const result: IDocumentsQueryResult = {
                  documentsList: res,
                  clientEntityIds: action.payload.entityIds
                };
                return of(
                  new DocumentLibraryActions.GetDocumentsSuccess(result)
                );
              }
            }
          })
          , catchError((err: HttpErrorResponse) => {
            const errorMessage: string = (err && err.message) ? err.message : (err && err.error && err.error.message) ? err.error.message : 'An unknown error has occured';
            /**
             * when there's a permissioning error, don't show it to the user
             */
            if (err.status === 403) {
              return of(
                new DocumentLibraryActions.GetDocumentsSuccess([]),
                new GlobalNotificationActions.NotificationErrorAction(errorMessage)
              );
            } else {
              return of(
                new DocumentLibraryActions.GetDocumentsError(errorMessage),
                new GlobalNotificationActions.NotificationErrorAction(errorMessage)
              );
            }
          })
        );
    })
  ));

  downloadDocument$ = createEffect(() => this.actions$.pipe(
    ofType<DocumentLibraryActions.DownloadDocument>(DocumentLibraryActions.DocumentLibraryActionTypes.DOWNLOAD_DOCUMENT),
    switchMap((action: DocumentLibraryActions.DownloadDocument) => {
      return this.documentLibraryService.downloadDocument(<IDocumentDownloadRequestObject>action.payload)
        .pipe(
          switchMap((res: any) => {
            if (res) {
              if (res.errorMessage) {
                return of(
                  new DocumentLibraryActions.DownloadDocumentFailure(res.errorMessage),
                  new GlobalNotificationActions.NotificationErrorAction(res.errorMessage)
                );
              } else {
                return of(
                  new DocumentLibraryActions.WriteFileFromBlob(res)
                );
              }
            }
          })
          , catchError((err) => {
            const errorMessage: string = (err && err.message) ? err.message : (err && err.error && err.error.message) ? err.error.message : 'An unknown error has occured';
            return of(
              new DocumentLibraryActions.DownloadDocumentFailure(errorMessage),
              new GlobalNotificationActions.NotificationErrorAction(errorMessage)
            );
          })
        );
    })
  ));

  writeFileFromBlob$ = createEffect(() => this.actions$.pipe(
    ofType(DocumentLibraryActions.DocumentLibraryActionTypes.WRITE_FILE_FROM_BLOB),
    switchMap((action: DocumentLibraryActions.WriteFileFromBlob) => {
      return this.documentLibraryService.writeFileFromBlob(action.payload)
        .pipe(
          map((res: any) => {
            return new DocumentLibraryActions.DownloadDocumentSuccess('success!');
          })
          , catchError((err) => {
            const errorText = parseError(err, "PDF could not be written");
            return of(
              new ErrorActions.NotificationErrorAction(errorText),
              new DocumentLibraryActions.DownloadDocumentFailure(errorText)
            );
          })
        );
    })
  ));
}
